<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <ul
          class="search_item"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
        >
          <li v-for="(item, index) in state.ProductList" :key="index">
            <el-image
              :src="item.smallPhoto"
              contain
              lazy
              @click="goDetail(item.id)"
            ></el-image>
          </li>
        </ul>
        <div class="view_load">
          <div class="" v-if="state.loading">加载中...</div>
          <div class="" v-if="noMore">没有更多了</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, onMounted, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { posts } from '../utils/posts'
import crumb from '../components/bread-crumb/Index.vue'
export default {
  name: '产品搜索页面',
  components: {
    crumb
  },
  setup () {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const userInfo = store.state.userInfo || { uid: 0 }
    const state = reactive({
      page: 1,
      pageSize: 18,
      search: store.state.serachContent,
      buildId: route.query.buildId || 0,
      smallClassId: 0,
      orderBy: 0,
      loading: false,
      ProductList: [],
      list: [],
      count: 1, // 当前页面娄
      pageCount: 0, // 总页面数
      totalCount: 0 // 产品总数
    })
    watch(
      () => store.state.serachContent,
      (newVal) => {
        state.search = newVal
        state.ProductList = []
        ProducHandler()
      }
    )
    const noMore = computed(() => state.count >= state.pageCount)
    const disabled = computed(() => state.loading || noMore.value)
    // 滚动加载
    const load = () => {
      state.loading = true
      state.count++
      ProducHandler()
      state.loading = false
    }
    // 获取商品列表
    const ProducHandler = () => {
      posts('product/getProducts/' + userInfo.uid, {
        page: state.count,
        pageSize: state.pageSize,
        search: state.search,
        buildId: state.buildId,
        smallClassId: state.smallClassId,
        orderBy: state.orderBy
      }).then((res) => {
        state.totalCount = res.totalCount
        state.pageCount = res.pageCount
        state.list = state.ProductList.concat(res.data)
        state.ProductList = state.list
        state.loading = false
      })
    }
    const goDetail = (id) => {
      router.push({ path: '/product/detail', query: { pid: id } })
    }
    onMounted(() => {
      ProducHandler()
    })
    return {
      goDetail,
      load,
      state,
      noMore,
      disabled
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 1200px;
}
.lg {
  display: flex;
  flex-wrap: wrap;
  margin: 26px 0 0 0;
  .view_load {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }
  .search_item {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 218px;
      height: 218px;
      overflow: hidden;
      margin: 0 22px 24px 0;
      cursor: pointer;
      transition: all 0.5s ease 0s;
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}
</style>
